/* tslint:disable */
/* eslint-disable */
/**
 * esign
 * eSign template authoring and request management service
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const PublicSignerErrorCode = {
    Invalid: 'invalid',
    Expired: 'expired',
    Superseded: 'superseded',
    Completed: 'completed',
    Cancelled: 'cancelled',
    ValidationFailed: 'validation_failed',
    RateLimited: 'rate_limited',
    ServerError: 'server_error',
} as const;
export type PublicSignerErrorCode = typeof PublicSignerErrorCode[keyof typeof PublicSignerErrorCode];


export function instanceOfPublicSignerErrorCode(value: any): boolean {
    for (const key in PublicSignerErrorCode) {
        if (Object.prototype.hasOwnProperty.call(PublicSignerErrorCode, key)) {
            if (PublicSignerErrorCode[key as keyof typeof PublicSignerErrorCode] === value) {
                return true;
            }
        }
    }
    return false;
}

export function PublicSignerErrorCodeFromJSON(json: any): PublicSignerErrorCode {
    return PublicSignerErrorCodeFromJSONTyped(json, false);
}

export function PublicSignerErrorCodeFromJSONTyped(json: any, ignoreDiscriminator: boolean): PublicSignerErrorCode {
    return json as PublicSignerErrorCode;
}

export function PublicSignerErrorCodeToJSON(value?: PublicSignerErrorCode | null): any {
    return value as any;
}

export function PublicSignerErrorCodeToJSONTyped(value: any, ignoreDiscriminator: boolean): PublicSignerErrorCode {
    return value as PublicSignerErrorCode;
}

